import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MyserviceService } from '../../provider/myservice.service';
import {marketPlace} from '../../language/market-place';
import {transform,styleFunction,source,layer,view,map,vectorLayer} from '../../global/style';
import Swal from 'sweetalert2';
import OlMap from "ol/map";
import OlTileWMS from "ol/source/TileWMS";
import OlTileLayer from "ol/layer/tile";
import OlView from "ol/View";
// import VectorSource from "ol/source/Vector";
// import VectorLayer from "ol/layer/Vector";
import Point from 'ol/geom/Point.js';
// import Feature from 'ol/Feature';
import Icon from 'ol/style/icon';
// import Style from 'ol/style/Style';
// import GeoJSON from 'ol/format/GeoJSON';
import { Tooltip } from 'chart.js';
import Overlay from "ol/Overlay";
import { PopoverConfig } from 'ngx-bootstrap/popover';
declare var ol: any;
import * as $ from 'jquery';
import * as moment from 'moment';
import 'ol/ol.css';
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import View from 'ol/View';
import GeoJSON from 'ol/format/GeoJSON';
import Circle from 'ol/geom/Circle';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {OSM, Vector as VectorSource} from 'ol/source';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';
@Component({
  selector: 'app-market-place',
  templateUrl: './market-place.component.html',
  styleUrls: ['./market-place.component.scss']
})
export class MarketPlaceComponent implements OnInit {
  lang=localStorage.getItem('lang')=="EN"?"EN":"TH";
  language:any;
  map: OlMap;
  source: OlTileWMS;
  layer: OlTileLayer;
  view: OlView;
  markerSource: VectorSource;
  file:any;
  geojson:any;
  show_map=true;
  show_marker=false;
  place_name="";
  constructor(private route: ActivatedRoute, private router: Router,private service:MyserviceService) { }

  ngOnInit() {
    this.service.postData({},"market-place/get").then((result:any)=>{
      if(!result.code){
        this.geojson=result.data;
        setTimeout(()=>{
          this.draw_map();
        },500)
      }
    })
    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        this.language=marketPlace[this.lang];
      }else{
        this.language=marketPlace[this.lang];
        localStorage.setItem('lang',this.lang);
      }
   });

  }
  onFileChange(e) {
    const file = e.target.files[0];

     console.log(file);
     this.file=file;

    // reader.readAsDataURL(file);
    // //console.log(e);
  }
  upload(){
    console.log(this.file);
    var fd=new FormData();
    fd.append("file",this.file)
    this.service.upload("market-place/upload",fd).then((result:any)=>{
      if(!result.code){
        Swal.fire({
          title: this.language.saved,
          text: '',
          type: 'success',
          showCancelButton: false,
          showConfirmButton: false,
          timer:2000
        }).then((result)=>{
          this.show_map=false;
          setTimeout(()=>{
            this.show_map=true;
            this.service.postData({},"market-place/get").then((result:any)=>{
              if(!result.code){
                this.geojson=result.data;
                setTimeout(()=>{
                  this.draw_map();
                },500)
              }
            })
          },500);
        })


      }else{
        Swal.fire({
          title: result.message,
          text: '',
          type: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          timer:2000
        })
      }
    })
  }
  focus(position,name){
    var center;
    this.place_name=name;
    this.show_marker=true;
   setTimeout(()=>{
    switch(position.type){
      case 'MultiPolygon':
        center=position.coordinates[0][0][0];

    }
  //   var iconStyle = new Style({
  //     image: new Icon({
  //       anchor: [0.5, 1],
  //       scale: 0.5,
  //       src: '/assets/img/marker.png',
  //       crossOrigin: "Anonymous",
  //     })
  //   })
  //   var iconFeature = new Feature({
  //     type: 'icon',
  //     geometry: new Point(ol.proj.transform( center,
  //       "EPSG:4326",
  //       "EPSG:900913")),
  //   });
  //  iconFeature.setStyle(iconStyle)
  //   var feature = this.markerSource.getFeatures()
  //   for (let i in feature) {
  //     this.markerSource.removeFeature(feature[i])
  //   }
  //   this.markerSource.addFeatures([iconFeature])
      var marker = new Overlay({
        position: ol.proj.fromLonLat(center),
        positioning: 'center-center',
        element: document.getElementById("marker"),
        stopEvent: false
      });
  this.map.addOverlay(marker);
    this.map.getView().setCenter(ol.proj.transform( center,
      "EPSG:4326",
      "EPSG:900913"));
      this.map.getView().setZoom(18);

   },500)
//   CenterMap(long, lat) {
//     console.log("Long: " + long + " Lat: " + lat);
  }
// }
  draw_map(){


    // console.log(this.geojson);
   var data = this.geojson!=null?JSON.parse(JSON.stringify(this.geojson)):null;

   this.markerSource = new VectorSource({
      features: []
    });
    var vectorLayer1 = new VectorLayer({
      source: this.markerSource
    });
    this.view =view;
    this.layer=layer;
    this.map = new OlMap({
      target: "map",
      layers: [this.layer, vectorLayer(JSON.parse(JSON.stringify(this.geojson))),vectorLayer1],
      view: this.view
    });
    this.map.render();
    var iconStyle = new Style({
      image: new Icon({
        anchor: [0.5, 0.5],
        scale: 1,
        src: '/assets/img/marker.png',
        crossOrigin: "Anonymous",
      })
    })
    var markers=[];

  }

}
